import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import asyncComponent from "../../../util/asyncComponent";

const Form = ({ match }) => (
  <div>
    <Switch>
      <Redirect
        exact
        from={`${match.url}/`}
        to={`${match.url}/selecttraining`}
      />

      <Route
        path={`${match.url}/valoracion`}
        component={asyncComponent(() => import("./routes/valoracion"))}
      />

      <Route
        component={asyncComponent(() =>
          import("app/routes/extraPages/routes/404")
        )}
      />
    </Switch>
  </div>
);

export default Form;



// WEBPACK FOOTER //
// ./app/routes/selecttraining/index.js